/* MAHA — bloque "whatsapp_quote" de la PDP (productos personalizables).
   Reconstruye el mensaje (mismo formato que arma
   snippets/whatsapp-quote-cta.liquid en el primer render) cuando cambia la
   variante seleccionada o la cantidad, y reutiliza
   window.MahaWhatsappQuote.updateHref (assets/whatsapp-quote.js) para volver
   a calcular el href -- no duplica esa formula.

   El SKU/título de la variante se leen directo del
   <script data-selected-variant> dentro de <variant-selects> (mismo elemento
   que product-info.js usa como fuente de verdad vía getSelectedVariant), en
   vez de confiar en el detail del evento "variant:changed": product-info.js
   nunca reasigna this.currentVariant en su ruta más común
   (handleUpdateProductInfo), así que ese evento viaja con un variant
   obsoleto -- bug preexistente, ajeno a este bloque. */
(function () {
  'use strict';
  if (window.__mahaWhatsappQuotePdpInit) return;
  window.__mahaWhatsappQuotePdpInit = true;

  function setup(el) {
    var baseMessage = el.getAttribute('data-base-message') || '';
    var productTitle = el.getAttribute('data-product-title') || '';
    var productUrl = el.getAttribute('data-product-url') || '';
    var minQty = el.getAttribute('data-min-qty') || '1';
    var initialSku = el.getAttribute('data-variant-sku') || '';
    var initialVariantTitle = el.getAttribute('data-variant-title') || '';
    var scope = el.closest('.shopify-section') || document;

    function getQuantityInput() {
      return scope.querySelector('.quantity__input.js-qty__num');
    }
    function getFormatText() {
      var span = scope.querySelector('.sales-formatText');
      var text = span ? span.textContent.trim() : '';
      return text;
    }
    function getCurrentVariant() {
      var script = scope.querySelector('variant-selects script[data-selected-variant]');
      if (script) {
        try {
          var data = JSON.parse(script.textContent);
          if (data) return data;
        } catch (e) {
          /* JSON malformado o vacío: usar el fallback de abajo */
        }
      }
      return { sku: initialSku, title: initialVariantTitle };
    }

    function rebuild() {
      var variant = getCurrentVariant();
      var qtyInput = getQuantityInput();
      var qty = qtyInput && qtyInput.value ? qtyInput.value : minQty;
      var format = getFormatText();

      var lines = [baseMessage, '', 'Producto: ' + productTitle];
      if (variant && variant.sku) {
        lines.push('SKU: ' + variant.sku);
      }
      if (variant && variant.title && variant.title !== 'Default Title') {
        lines.push('Variante: ' + variant.title);
      }
      if (qty) {
        lines.push('Cantidad: ' + qty);
      }
      if (format) {
        lines.push('Formato: ' + format + 'pz');
      }
      lines.push('Enlace: ' + productUrl);

      var message = lines.join('\n');
      el.setAttribute('data-whatsapp-message', message);
      if (window.MahaWhatsappQuote) window.MahaWhatsappQuote.updateHref(el);
    }

    document.addEventListener('variant:changed', rebuild);

    var qtyInput = getQuantityInput();
    if (qtyInput) {
      ['change', 'input'].forEach(function (evtName) {
        qtyInput.addEventListener(evtName, rebuild);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-whatsapp-quote-pdp]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
